import React from "react";
import "./SvgIcon.scss";
import SVG from "react-inlinesvg";
import PropTypes from "prop-types";
import { selectIcon } from "../../UI/selector";

const SvgIcon = ({ icon, disabled, click }) => (
  <SVG
    src={selectIcon(icon)} onClick={click}
    className={`${icon}${disabled ? " disable_icon" : ""}`}
  />
);

SvgIcon.propTypes = {
  disabled: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  click: PropTypes.func
};

SvgIcon.defaultProps = {
  disabled: false,
  icon: selectIcon("userDummy"),
  click: () => null,
};


export default SvgIcon;